import React from 'react';
import { NavLink } from 'react-router-dom';
import './Projektanfrage.css'; // Importiere das zugehörige CSS

const ProjektanfrageButton = () => {
  return (
    <NavLink to="/projektanfrage" className="projektanfrage-link">
      Projektanfrage
    </NavLink>
  );
};

export default ProjektanfrageButton;